module.exports = __webpack_public_path__ + "img/bgc2.afbcab3b.png";